import { Link } from '@tanstack/react-router'
import type { ReactElement, ReactNode } from 'react'

import type { TellerSearchValues } from './navigation'

interface TellerLinkProps {
  /** A path from `TELLER_PATHS`. Typed as a string until the integrator registers these routes. */
  to: string
  search?: TellerSearchValues
  replace?: boolean
  className?: string
  children?: ReactNode
  'aria-label'?: string
}

/**
 * `Link`, addressed by path string — the counterpart of `useTellerNavigate`, and the same seam for
 * the same reason: these routes are not in the registered tree yet, so the typed `to` union does
 * not contain them.
 *
 * It stays a real `Link`, which matters more than it looks: preloading on intent, the active state,
 * and — the reason it is not an anchor — client-side navigation that keeps the query cache warm, so
 * moving from the session list into a session does not refetch the drawer that is on screen.
 */
export const TellerLink = Link as unknown as (props: TellerLinkProps) => ReactElement
